"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * session-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllType = exports.SessionApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class SessionApi extends runtime.BaseAPI {
    /**
     */
    assignRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling assign.');
            }
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling assign.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/assign/{expertId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.OptionalRequestBaseAssignRequestPayloadToJSON(requestParameters.optionalRequestBaseAssignRequestPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    assign(sessionId, expertId, optionalRequestBaseAssignRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.assignRaw({ sessionId: sessionId, expertId: expertId, optionalRequestBaseAssignRequestPayload: optionalRequestBaseAssignRequestPayload });
            return yield response.value();
        });
    }
    /**
     */
    cancelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling cancel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/cancel`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestMetaToJSON(requestParameters.requestMeta),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    cancel(sessionId, requestMeta) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelRaw({ sessionId: sessionId, requestMeta: requestMeta });
        });
    }
    /**
     */
    closeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling close.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/close`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestMetaToJSON(requestParameters.requestMeta),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    close(sessionId, requestMeta) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.closeRaw({ sessionId: sessionId, requestMeta: requestMeta });
            return yield response.value();
        });
    }
    /**
     */
    createRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/create`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseSessionCreationPayloadObsoleteToJSON(requestParameters.requestBaseSessionCreationPayloadObsolete),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    create(requestBaseSessionCreationPayloadObsolete) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRaw({ requestBaseSessionCreationPayloadObsolete: requestBaseSessionCreationPayloadObsolete });
            return yield response.value();
        });
    }
    /**
     */
    createAssignedRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/create/assigned`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseSessionAssignedCreationPayloadToJSON(requestParameters.requestBaseSessionAssignedCreationPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    createAssigned(requestBaseSessionAssignedCreationPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createAssignedRaw({ requestBaseSessionAssignedCreationPayload: requestBaseSessionAssignedCreationPayload });
            return yield response.value();
        });
    }
    /**
     */
    createPendingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/create/pending`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseSessionPendingCreationPayloadToJSON(requestParameters.requestBaseSessionPendingCreationPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    createPending(requestBaseSessionPendingCreationPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createPendingRaw({ requestBaseSessionPendingCreationPayload: requestBaseSessionPendingCreationPayload });
            return yield response.value();
        });
    }
    /**
     */
    createUnassignedRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/create/unassigned`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseSessionUnassignedCreationPayloadToJSON(requestParameters.requestBaseSessionUnassignedCreationPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    createUnassigned(requestBaseSessionUnassignedCreationPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createUnassignedRaw({ requestBaseSessionUnassignedCreationPayload: requestBaseSessionUnassignedCreationPayload });
            return yield response.value();
        });
    }
    /**
     */
    getRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling get.');
            }
            const queryParameters = {};
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    get(sessionId, correlationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRaw({ sessionId: sessionId, correlationId: correlationId });
            return yield response.value();
        });
    }
    /**
     * Get sessions, filter parameters could not be empty arrays
     */
    getAllRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.statuses) {
                queryParameters['statuses'] = requestParameters.statuses;
            }
            if (requestParameters.pools) {
                queryParameters['pools'] = requestParameters.pools;
            }
            if (requestParameters.expertise) {
                queryParameters['expertise'] = requestParameters.expertise;
            }
            if (requestParameters.expertIds) {
                queryParameters['expertIds'] = requestParameters.expertIds;
            }
            if (requestParameters.customerId !== undefined) {
                queryParameters['customerId'] = requestParameters.customerId;
            }
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            if (requestParameters.limitOrderDirection !== undefined) {
                queryParameters['limitOrderDirection'] = requestParameters.limitOrderDirection;
            }
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.projection !== undefined) {
                queryParameters['projection'] = requestParameters.projection;
            }
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.PartialSessionFromJSON));
        });
    }
    /**
     * Get sessions, filter parameters could not be empty arrays
     */
    getAll(statuses, pools, expertise, expertIds, customerId, correlationId, limitOrderDirection, limit, projection, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllRaw({ statuses: statuses, pools: pools, expertise: expertise, expertIds: expertIds, customerId: customerId, correlationId: correlationId, limitOrderDirection: limitOrderDirection, limit: limit, projection: projection, type: type });
            return yield response.value();
        });
    }
    /**
     */
    getSessionsCountRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.statuses) {
                queryParameters['statuses'] = requestParameters.statuses;
            }
            if (requestParameters.pools) {
                queryParameters['pools'] = requestParameters.pools;
            }
            if (requestParameters.attributes) {
                queryParameters['attributes'] = requestParameters.attributes;
            }
            if (requestParameters.assignedExperts) {
                queryParameters['assignedExperts'] = requestParameters.assignedExperts;
            }
            if (requestParameters.customerId !== undefined) {
                queryParameters['customerId'] = requestParameters.customerId;
            }
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/count`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.InlineResponse200FromJSON(jsonValue));
        });
    }
    /**
     */
    getSessionsCount(statuses, pools, attributes, assignedExperts, customerId, correlationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSessionsCountRaw({ statuses: statuses, pools: pools, attributes: attributes, assignedExperts: assignedExperts, customerId: customerId, correlationId: correlationId });
            return yield response.value();
        });
    }
    /**
     */
    getUnassignedSessionsIdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pools) {
                queryParameters['pools'] = requestParameters.pools;
            }
            if (requestParameters.expertise) {
                queryParameters['expertise'] = requestParameters.expertise;
            }
            if (requestParameters.assignedExperts) {
                queryParameters['assignedExperts'] = requestParameters.assignedExperts;
            }
            if (requestParameters.customerId !== undefined) {
                queryParameters['customerId'] = requestParameters.customerId;
            }
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/unassigned/ids`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    getUnassignedSessionsId(pools, expertise, assignedExperts, customerId, correlationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUnassignedSessionsIdRaw({ pools: pools, expertise: expertise, assignedExperts: assignedExperts, customerId: customerId, correlationId: correlationId });
            return yield response.value();
        });
    }
    /**
     */
    reassingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling reassing.');
            }
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling reassing.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/reassign/{expertId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestMetaToJSON(requestParameters.requestMeta),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    reassing(sessionId, expertId, requestMeta) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reassingRaw({ sessionId: sessionId, expertId: expertId, requestMeta: requestMeta });
        });
    }
    /**
     */
    removeAttributeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling removeAttribute.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/attributes/remove`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseRemoveAttributeRequestPayloadToJSON(requestParameters.requestBaseRemoveAttributeRequestPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    removeAttribute(sessionId, requestBaseRemoveAttributeRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.removeAttributeRaw({ sessionId: sessionId, requestBaseRemoveAttributeRequestPayload: requestBaseRemoveAttributeRequestPayload });
            return yield response.value();
        });
    }
    /**
     */
    republishSessionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/republish`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseRepublishRequestPayloadToJSON(requestParameters.requestBaseRepublishRequestPayload),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    republishSessions(requestBaseRepublishRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.republishSessionsRaw({ requestBaseRepublishRequestPayload: requestBaseRepublishRequestPayload });
        });
    }
    /**
     */
    resolveRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling resolve.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/resolve`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.OptionalRequestBaseResolvedRequestPayloadToJSON(requestParameters.optionalRequestBaseResolvedRequestPayload),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    resolve(sessionId, optionalRequestBaseResolvedRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.resolveRaw({ sessionId: sessionId, optionalRequestBaseResolvedRequestPayload: optionalRequestBaseResolvedRequestPayload });
        });
    }
    /**
     */
    unassignRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling unassign.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/unassign`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseUnassignRequestPayloadToJSON(requestParameters.requestBaseUnassignRequestPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    unassign(sessionId, requestBaseUnassignRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unassignRaw({ sessionId: sessionId, requestBaseUnassignRequestPayload: requestBaseUnassignRequestPayload });
            return yield response.value();
        });
    }
    /**
     */
    upsertAttributesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling upsertAttributes.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aadIssuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/session/{sessionId}/attributes/upsert`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseUpsertAttributesRequestPayloadToJSON(requestParameters.requestBaseUpsertAttributesRequestPayload),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionFromJSON(jsonValue));
        });
    }
    /**
     */
    upsertAttributes(sessionId, requestBaseUpsertAttributesRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.upsertAttributesRaw({ sessionId: sessionId, requestBaseUpsertAttributesRequestPayload: requestBaseUpsertAttributesRequestPayload });
            return yield response.value();
        });
    }
}
exports.SessionApi = SessionApi;
/**
    * @export
    * @enum {string}
    */
var GetAllType;
(function (GetAllType) {
    GetAllType["Task"] = "Task";
    GetAllType["Remote"] = "Remote";
})(GetAllType = exports.GetAllType || (exports.GetAllType = {}));
